import { cn } from '@udecode/cn';
import { CheckCheckIcon, XIcon } from 'lucide-react';

export interface SuggestionToolbarProps {
    suggestionCount: number;
    onAcceptAll: () => void;
    onRejectAll: () => void;
    className?: string;
}

export const SuggestionToolbar = ({
    suggestionCount,
    onAcceptAll,
    onRejectAll,
    className
}: SuggestionToolbarProps) => {
    return (
        <div className={cn(
            'flex flex-row items-center justify-center gap-4 flex-wrap',
            className
        )}>
            <div className='flex flex-row items-center gap-2 text-base text-gray-700 font-semibold sm:grow'>
                Návrhů změn: <span className='font-medium text-gray-900 text-sm flex flex-row items-center px-1.5 py-0.5 bg-gray-200 rounded-full'>{suggestionCount}</span>
            </div>
            <div className='flex flex-row items-center gap-2'>
                <button
                    className='flex flex-row items-center py-2 px-4 gap-1 rounded-full bg-lime-600 hover:bg-lime-700 text-white text-sm font-medium transition-all duration-200'
                    onClick={onAcceptAll}
                >
                    <CheckCheckIcon size={18} className='flex-shrink-0' />
                    <span>Přijmout vše</span>
                </button>
                <button
                    className='flex flex-row items-center py-2 px-4 gap-1 rounded-full bg-red-600 hover:bg-red-700 text-white text-sm font-medium transition-all duration-200'
                    onClick={onRejectAll}
                >
                    <XIcon size={18} className='flex-shrink-0' />
                    <span>Odmítnout vše</span>
                </button>
            </div>
        </div>
    );
};
